var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSandboxEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 447,
    height: 537,
    viewBox: "0 0 447 537",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 307,
    cy: 280.5,
    r: 307,
    fill: "#F6FAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandboxEllipse);
export default __webpack_public_path__ + "static/media/SandboxEllipse.f307b7b0ad799772c9804e7aae962c9e.svg";
export { ForwardRef as ReactComponent };